export const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
    padding: 0,
    width: "100%",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
  },
  appTabs: {
    boxShadow: "none",
    marginBottom: theme.spacing(3),
    backgroundColor: "transparent",
    textTransform: "uppercase",
  },
  tabsRoot: {
    borderBottom: "1px solid #e8e8e8",
    overflowX: "auto !important",
  },
  tabsIndicator: {
    backgroundColor: "#1890ff",
  },
  tabRoot: {
    maxWidth: theme.spacing(30),
    minWidth: theme.spacing(9),
    minHeight: theme.spacing(6),
    marginRight: theme.spacing(2),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  textColorPrimary: {
    fontWeight: "500",
    textTransform: "uppercase",
    lineHeight: 1.75,
    whiteSpace: "normal",
    letterSpacing: "0.02857em",
    fontSsize: "0.8125rem",
    color: "#000",
    opacity: 0.7,
  },
  selected: {
    color: "#000 !important",
    opacity: "1 !important",
  },
  item: {
    display: "flex",
    flexDirection: "column",
  },
  button: {
    marginTop: theme.spacing(3),
  },
});

export const informationStyle = (theme) => ({
  menu: {
    width: "15%",
  },
  fixItemContainer: {
    display: "unset",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(3),
  },
  actives: {
    fontSize: "0.8rem",

    marginLeft: "60px",
    display: "inline-block",
  },
  image: {
    height: "25vw",
    width: "45vw",
    // border: '2px solid #F2F2F2',
    // margin: '20px 0px',
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  icon: {
    fontSize: 80,
  },
  input: {},
  label: {
    fontSize: "1.125rem",
    fontWeight: 500,
  },
  // containerMargin: {
  //   margin: '12px 0px 12px 0px',
  //   padding: '0px 24px 0px 0px'
  // },

  note: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  // description: {
  //   marginTop: theme.spacing(2),
  //   marginBottom: theme.spacing(2),
  // },
  helperText: {
    color: "#1E1E83",
    cursor: "pointer",
    // fontSize: '0.675rem',
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: theme.spacing(3),
    width: "80%",
    backgroundColor: "#ffffff",
  },
  // modify
  supportContainer: {
    marginTop: -3,
  },
  inputMultiline: {
    "@media only screen and (min-width:768.98px) and (max-width:1024px) ": {
      height: "20px !important",
    },
    "@media only screen and (min-width:600.98px) and (max-width:768px) ": {
      height: "42px !important",
    },
  },
  customFormLabel: {
    display: "block",
    transformOrigin: "top left",
    transform: "translate(0, 1.5px) scale(0.75)",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500",
  },
  containerLabel: {
    paddingBottom: "0 !important",
  },
  containerImage: {
    position: "relative",
    width: "45vw",
  },
  containerAddressCityDistrict: {
    "@media screen and (min-width: 1328.98px) and (max-width: 1366px)": {
      display: "flex",
      flexDirection: "row",
    },
    "@media screen and (min-width: 1280.98px) and (max-width: 1328px)": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    "@media only screen and (min-width:940.98px) and (max-width:1280px) and (orientation:landscape)": {
      display: "flex",
      flexDirection: "row",
      alignItems: "end",
    },
    "@media only screen and (min-width:768.98px) and (max-width:940px) ": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    "@media only screen and (min-width:768.98px) and (max-width:1024px) ": {
      display: "flex",
      flexDirection: "row",
      alignItems: "end",
    },
    "@media only screen and (min-width:600.98px) and (max-width:768px) ": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  },
});

export const featureStyle = (theme) => ({
  inputLabel: {
    textTransform: "capitalize",
    fontSize: "1rem",
  },
  helperText: {
    margin: 0,
  },
  root: {
    width: "100%",
    boxSizing: "border-box",
  },
  label: {
    // marginBottom: theme.spacing(2),
  },
  boxButton: {
    width: "100%",
    textAlign: "right",
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: "-webkit-fill-available",
    boxSizing: "border-box",
    marginLeft: -theme.spacing(3),
    marginRight: -theme.spacing(3),
  },
  container: {
    marginTop: theme.spacing(6),
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
  },
});
export const qrcodeStyle = (them) => ({
  containerMenu: {
    padding: "1rem",
    flexDirection: "column",
    display: "flex",
  },
  qrCode: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  button: {
    marginTop: "16px",
    marginBottom: "8px",
    width: "100%",
  },
  qrcodeContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
});

export const fanpageStyle = (theme) => ({
  button: {
    float: "right",
  },
});

export const settingStyle = (theme) => ({
  group: {
    marginBottom: theme.spacing(2),
  },
  label: {
    fontWeight: "bold",
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  button: {
    float: "right",
  },
});
